//GROUP SHARING

import React, { Component } from "react"; //  { Component, Children }
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import {
  Button,
  FormGroup,
  ControlLabel,
  FormControl,
  Row,
} from "react-bootstrap";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import TimeStamp from "react-timestamp";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import axios from "axios";

import { customLog } from "../../variables/Variables";
import _ from "lodash";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
// No Data Found
import NoDataFound from "../Errors/NoDataFound";
// Loading
import Loading from "../../components/Loading/Loading";
// Authorization
import withAuthorization from "../../components/Authorization/withAuthorization";
// Firebase
import { fire, auth } from "../../firebase/index";
import "../../routes/app";
import Switch from "react-switch";

import "../../assets/css/mapview.css";

import Multiselect from "react-widgets/lib/Multiselect";
import "react-widgets/dist/css/react-widgets.css";
import "../../assets/css/header.css";

const center = {
  textAlign: "center",
};

class GroupShare extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    // Rendering of Tables
    this.renderLockListArray = this.renderLockListArray.bind(this);
    // Force Update
    this.forceUpdateHandler = this.forceUpdateHandler.bind(this);
    this.handlewindowShow = this.handlewindowShow.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.eraseAll = this.eraseAll.bind(this);

    this.state = {
      locklistArray: [],
      userFriendListArray: [],
      loading: true,
      selectedLock: "",
      userArray: [],

      actualDateTime: 0,
      startDate: 0,
      endDate: 0,
      count: 0,
      show: false,

      approvalchecked: false,
      timechecked: false,
      selectedFriendsAccountExists: false,
      isRetractMode: true,

      //sharing variable
      selectedLockName: "",
      selectedLockPassword: "",
      selectedLockModel: "",
      selectedLockSerial: "",
      selectedFriendsUID: "",
      selectedFriendsEmail: "",

      selectedStartShareTime: 0,
      selectedEndShareTime: 0,

      selectedStartTimeString: "",
      selectedEndTimeString: "",

      //NEW INDUSTRIAL FEATURE
      selectedShareCount: 0,
      selectedLockID: "",
      selectedLockOwnedBy: "",
      selectedIsOfflineLock: true,

      randomlyGeneratedAccessToken: "",

      lockNameToShare: "",
      readyToShare: false,
      calendarStartText: "Select your start time",
      calendarEndText: "Select your end time",
      calendarStartChangeText: "",

      selectedFriendsArray: [],
      multipleSelectedFriendsUID: "",
      multipleSelectedFriendsUIDWithoutAccount: "",

      isMultipleSendingMode: false,

      groupNameArray: [],
    };
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.detectOnLockDropdownChangeEvent = this.detectOnLockDropdownChangeEvent.bind(
      this
    );
    this.detectOnRecipientDropdownChangeEvent = this.detectOnRecipientDropdownChangeEvent.bind(
      this
    );
    this.pushSelectedLockToSelectedUser = this.pushSelectedLockToSelectedUser.bind(
      this
    );
    this.createAccessToken = this.createAccessToken.bind(this);
    this.handleRequireApproval = this.handleRequireApproval.bind(this);
    this.handleTimedAccess = this.handleTimedAccess.bind(this);
    this.snapshotToArray = this.snapshotToArray.bind(this);
    this.handleFriendsArray = this.handleFriendsArray.bind(this);
    this.lookUpAllUIDsGivenEmailsThenShareLocksToMultipleUsers = this.lookUpAllUIDsGivenEmailsThenShareLocksToMultipleUsers.bind(
      this
    );
    this.sendAllLocksToSelectedUsers = this.sendAllLocksToSelectedUsers.bind(
      this
    );
    this.multiplePushUserAccessRegistryOnlineAccessToFirebase = this.multiplePushUserAccessRegistryOnlineAccessToFirebase.bind(
      this
    );
    this.multiplePushShareUserRecordToShareHistory = this.multiplePushShareUserRecordToShareHistory.bind(
      this
    );
  }
  snapshotToArray = (snapshot) => {
    var returnArr = [];
    snapshot.forEach(function(childSnapshot) {
      var item = childSnapshot.val();
      item.key = childSnapshot.key;
      returnArr.push(item);
    });
    return returnArr;
  };

  async handleStartDateChange(startDate) {
    var dateFormatted = startDate.getTime() / 1000;
    var actualDateTime = Math.floor(Date.now() / 1000);

    await this.setState({
      startDate: startDate,
      calendarStartText: startDate.toString(),
      selectedStartShareTime: parseInt(dateFormatted, 0),
      selectedStartTimeString: startDate.toString(),
      actualDateTime: actualDateTime.toString(),
    });
    customLog("Start Date: " + this.state.selectedStartTimeString);
  }

  async handleEndDateChange(endDate) {
    var dateFormatted = endDate.getTime() / 1000;
    await this.setState({
      endDate: endDate,
      calendarEndText: endDate.toString(),
      selectedEndShareTime: parseInt(dateFormatted, 0),
      selectedEndTimeString: endDate.toString(),
    });
    customLog("End Date: " + this.state.selectedEndTimeString);
  }

  handleRequireApproval(approvalchecked) {
    this.setState({ approvalchecked });
  }

  handleTimedAccess(timechecked) {
    customLog(timechecked);
    this.setState({ timechecked });
  }

  handleChange(isRetractMode) {
    this.setState({ isRetractMode });
  }

  componentWillMount() {
    fire
      .database()
      .ref("userLocks")
      .child(auth.currentUser.uid)
      .orderByKey()
      .once("value", function(snapshot) {
        snapshot.forEach(function(child) {});
      });

    fire
      .database()
      .ref("registeredIndustrialUsersOnPlatform")
      .orderByKey()
      .once("value")
      .then((snapshot) => {
        // customLog(snapshot);
        var tempArray = [];

        tempArray = this.snapshotToArray(snapshot);

        this.setState({
          userArray: tempArray,
          loading: false,
        });
      });

    fire
      .database()
      .ref("userLocks")
      .child(auth.currentUser.uid)
      .orderByKey()
      .once("value")
      .then((snapshot) => {
        // customLog(snapshot.val());
        this.setState({ locklistArray: snapshot.val(), loading: false });
      })
      .catch((err) => customLog(err));

    //Outdate database
    //TODO: Change to userFriendListIndustrial once ready.
    fire
      .database()
      .ref("userFriendList")
      .child(auth.currentUser.uid)
      .orderByKey()
      .once("value")
      .then((snapshot) => {
        // customLog(snapshot.val())
        this.setState({ userFriendListArray: snapshot.val(), loading: false });
      })
      .catch((err) => customLog(err));

    // axios
    //   .get(
    //     process.env.REACT_APP_FIREBASE_DATABASE +
    //     "/" +
    //     doGetUserlist() +
    //     ".json?auth=" +
    //     process.env.REACT_APP_FIREBASE_DATABASE_SECRET
    //   )
    //   .then(response => {
    //     // customLog(response.data);
    //     this.setState({ userFriendListArray: response.data, loading: false });
    //   })
    //   .catch(err => {
    //     customLog(err);
    //   });

    fire
      .database()
      .ref("userGroups")
      .child(auth.currentUser.uid)
      .orderByKey()
      .once("value")
      .then((snapshot) => {
        var tempArray = [];
        var tempMemberArray = [];

        tempArray = this.snapshotToArray(snapshot);

        tempArray.forEach((a) => {
          tempMemberArray.push(a.groupMembers);
        });

        this.setState({
          // groupMembersArray: tempMemberArray[0],
          groupNameArray: tempArray,
          loading: false,
        });
      });
  }

  forceUpdateHandler() {
    this.forceUpdate();
  }

  detectOnLockDropdownChangeEvent(event) {
    if (event.target.value === "null") {
      this.setState({
        selectedLockName: "",
      });
    } else {
      fire
        .database()
        .ref("userLocks")
        .child(auth.currentUser.uid)
        .orderByChild("Name")
        .equalTo(event.target.value)
        .once("value")
        .then((snapshot) => {
          snapshot.forEach((data) => {
            this.setState({
              selectedLockName: data.val().Name,
              selectedLockPassword: data.val().Password,
              selectedLockModel: data.val().Type,
              selectedLockSerial: data.val().ip45SerialNumber,

              //NEW INDUSTRIAL FEATURES
              selectedShareCount: data.val().shareCount,
              selectedLockID: data.val().id,
              selectedLockOwnedBy: data.val().ownedBy,
              selectedIsOfflineLock: data.val().isOfflineLock,
            });
          });
        });
      this.createAccessToken();
      this.forceUpdateHandler();
    }
  }

  multipleLockSharingAccess(useremails) {
    useremails.forEach(() => {
      customLog(useremails);
    });
  }

  detectOnRecipientDropdownChangeEvent(event) {
    customLog("event.target " + event.id);
    // var tempEmail = event.name;
    // fire.database().ref("registeredUsersOnPlatform").orderByValue().equalTo(event.name).once("value").then(snapshot => {
    //   if (snapshot.exists()) {
    //     snapshot.forEach(childSnapshot => {
    //       this.setState({
    //         selectedFriendsAccountExists: true,
    //         selectedFriendsUID: childSnapshot.key,
    //         selectedFriendsEmail: tempEmail
    //       });
    //       // customLog(childSnapshot.key);
    //       customLog(this.state.selectedFriendsAccountExists);
    //     });
    //   }
    // });

    var groupId = event.id;
    fire
      .database()
      .ref("userGroups")
      .child(auth.currentUser.uid)
      .child(groupId)
      .child("groupMembers")
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          snapshot.forEach((childSnapshot) => {
            this.setState({
              selectedFriendsAccountExists: true,
              selectedFriendsUID: childSnapshot.val().UID,
              selectedFriendsEmail: event.name,
              // selectedFriendsArray: childSnapshot.val()
            });
          });
        } else {
          customLog("not exist");
        }
      });
    this.createAccessToken();
    this.forceUpdateHandler();
  }

  handleFriendsArray(selectedFriends) {
    if (selectedFriends.length > 0) {
      var groupMembers = Object.values(selectedFriends);
      var groupId = [];
      var tempArray = [];
      groupMembers.forEach((a) => {
        groupId.push(a.id);
      });
      customLog(groupId);
      groupId.forEach((id) => {
        var groupId = id;
        fire
          .database()
          .ref("userGroups")
          .child(auth.currentUser.uid)
          .child(groupId)
          .child("groupMembers")
          .once("value")
          .then((snapshot) => {
            if (snapshot.exists()) {
              snapshot.forEach((childSnapshot) => {
                // this.setState({
                //   selectedFriendsArray: [{
                //     id: childSnapshot.val().email,
                //     name: childSnapshot.val().email
                //   }]
                // })
                var email = childSnapshot.val().email;
                tempArray.push(email);
              });
            } else {
              customLog("not exist");
            }
            this.setState({
              selectedFriendsArray: tempArray,
            });
          });

        this.setState({}, () => {
          // if (selectedFriends.length > 1) {
          //   this.setState({ isMultipleSendingMode: true })
          //   customLog("isMultipleSendingMode is true")
          // } else {
          //   this.setState({ isMultipleSendingMode: false })
          //   customLog("isMultipleSendingMode is false")
          // }
          this.setState({ isMultipleSendingMode: true });
        });
      });
      //  var groupId = Object.values(selectedFriends)[0].id

      //  fire.database().ref("userGroups").child(auth.currentUser.uid).child(groupId).child('groupMembers').once("value").then(snapshot => {
      //   if(snapshot.exists()) {
      //     var tempArray = []
      //     snapshot.forEach(childSnapshot => {
      //       // this.setState({
      //       //   selectedFriendsArray: [{
      //       //     id: childSnapshot.val().email,
      //       //     name: childSnapshot.val().email
      //       //   }]
      //       // })
      //       var email = childSnapshot.val().email
      //       tempArray.push(email)
      //     })
      //     this.setState({
      //       selectedFriendsArray: tempArray
      //     })
      //   }else {
      //     customLog('not exist')
      //   }
      // })

      //   this.setState({
      //   }
      //   , () => {
      //     // if (selectedFriends.length > 1) {
      //     //   this.setState({ isMultipleSendingMode: true })
      //     //   customLog("isMultipleSendingMode is true")
      //     // } else {
      //     //   this.setState({ isMultipleSendingMode: false })
      //     //   customLog("isMultipleSendingMode is false")
      //     // }
      //     this.setState({ isMultipleSendingMode: true })
      //   });
    } else {
      this.setState({
        selectedFriendsArray: "empty",
      });
    }
  }

  //select users
  //if user has no account, show a fading popup at the bottom, that the user has no account
  //if selectedUsers.length > 1 then run multipleShareMode
  //else its normal sharing

  //upon clicking SEND, look up all the UIDs using the emails, and place every UID into an array
  //for each email that returns nil, keep that email in an unsent Emails array
  //then, for each UID in UIDsArray, send the locks.
  lookUpAllUIDsGivenEmailsThenShareLocksToMultipleUsers(emails) {
    //take in selected emails from array
    //match email with UIDs
    //run for loop to look up UIDs
    //return all UIDs into an array

    //save emails without UIDs into an array

    var counterForAsyncEffect = 0;

    var tempEmailArray = [];
    var tempUIDArrayOfFoundEmailsWithAccount = [];
    var tempEmailsWithoutAccountArray = [];
    var tempEmailsWithAccountArray = [];

    customLog(emails);
    if (emails.length > 0) {
      emails.forEach((e) => {
        tempEmailArray.push(e);
      });

      tempEmailArray.forEach((email) => {
        fire
          .database()
          .ref("registeredUsersOnPlatform")
          .orderByValue()
          .equalTo(email)
          .once("value")
          .then((snapshot) => {
            if (snapshot.exists()) {
              snapshot.forEach((childSnapshot) => {
                tempUIDArrayOfFoundEmailsWithAccount.push(childSnapshot.key);
                tempEmailsWithAccountArray.push(childSnapshot.val());
              });
            } else {
              tempEmailsWithoutAccountArray.push(email);
            }
          });
        counterForAsyncEffect++;
      });
      if (counterForAsyncEffect === tempEmailArray.length) {
        setTimeout(() => {
          // cause we should have implemented promises but we didn't, so please do that! 😅
          tempUIDArrayOfFoundEmailsWithAccount.forEach((uid, i) => {
            //generate shared token
            this.sendAllLocksToSelectedUsers(uid);
            this.multiplePushUserAccessRegistryOnlineAccessToFirebase(
              tempEmailsWithAccountArray[i],
              uid
            );
            this.multiplePushShareUserRecordToShareHistory(
              tempEmailsWithAccountArray[i]
            );
            window.location.reload();
            //also update registry
            // customLog(tempEmailArray[i])
          });
        }, 500);
      }
    }
    // window.location.reload();
  }

  //with whats returned from lookUpAllUIDsGivenEmails,

  sendAllLocksToSelectedUsers(uid) {
    var incrementor = 0;
    incrementor = this.state.selectedShareCount;
    if (incrementor === 0) {
      incrementor = 1;
    } else {
      incrementor = 2;
    }

    var isOfflineModeBool = true;

    if (this.state.RequiredMode === true) {
      isOfflineModeBool = false;
    } else {
      isOfflineModeBool = true;
    }

    if (this.state.TimedMode === true) {
      isOfflineModeBool = false;
    } else {
      isOfflineModeBool = true;
    }

    if (this.state.isRetractMode === true) {
      isOfflineModeBool = false;
    } else {
      isOfflineModeBool = true;
    }

    //USE THIS FORMAT TO GENERATE THE PARENT ID
    var lockData = {
      Name: this.state.selectedLockName,
      Password: this.state.selectedLockPassword,
      Type: 4,
      ip45SerialNumber: this.state.selectedLockSerial,
      isShared: true,
      shareStartTime: this.state.selectedStartShareTime,
      shareEndTime: this.state.selectedEndShareTime,
      sharedBy: auth.currentUser.email,

      //NEW INDUSTRIAL FEATURES
      id: this.state.selectedLockID,
      ownedBy: this.state.selectedLockOwnedBy,
      shareAccessToken: this.state.randomlyGeneratedAccessToken,
      shareCount: incrementor,
      identifier: "",
      isOfflineLock: isOfflineModeBool,
    };

    fire
      .database()
      .ref("userLocks")
      .child(uid)
      .push(lockData);
  }

  multiplePushUserAccessRegistryOnlineAccessToFirebase(email, uid) {
    let key = fire
      .database()
      .ref("retractableSharingRegistry")
      .push().key;
    if (this.state.isRetractMode === true) {
      // //USE THIS FORMAT TO GENERATE THE PARENT ID
      var registryData = {
        shareStartTime: this.state.selectedStartShareTime,
        shareEndTime: this.state.selectedEndShareTime,
        sharedOn: new Date() / 1000,
        sharedToUID: uid,
        sharedToEmail: email,
        senderUID: auth.currentUser.uid,
        sharedLockName: this.state.selectedLockName,
        lockSerial: this.state.selectedLockSerial,
        lockId: this.state.selectedLockID,
        allowAccess: true,
        id: key,
        shareAccessToken: this.state.randomlyGeneratedAccessToken,
      };
      fire
        .database()
        .ref("retractableSharingRegistry")
        .child(auth.currentUser.uid)
        .child(key)
        .update(registryData);
    } else {
      //DO NOTHING
    }
  }

  //dealing with the unsent locks
  sendingMessageAboutUnregisteredUsers(emails) {
    //using the array of unregistered users
    //send a notification or alert of "Sorry these users have yet to have an account"
  }

  createAccessToken() {
    //TODO: CREATE ACCESS TOKEN
    let randomKey = fire
      .database()
      .ref()
      .push().key;
    this.setState({
      randomlyGeneratedAccessToken: randomKey,
    });
    // customLog(randomKey)
  }

  pushSelectedLockToSelectedUser() {
    //TODO: -> do some simple checking here
    var incrementor = 0;
    incrementor = this.state.selectedShareCount;
    if (incrementor === 0) {
      incrementor = 1;
    } else {
      incrementor = 2;
    }

    //IF RETRACT MODE IS ON { }
    var isOfflineModeBool = true;

    if (this.state.RequiredMode === true) {
      isOfflineModeBool = false;
    } else {
      isOfflineModeBool = true;
    }

    if (this.state.TimedMode === true) {
      isOfflineModeBool = false;
    } else {
      isOfflineModeBool = true;
    }

    if (this.state.isRetractMode === true) {
      isOfflineModeBool = false;
    } else {
      isOfflineModeBool = true;
    }

    //USE THIS FORMAT TO GENERATE THE PARENT ID
    var lockData = {
      Name: this.state.selectedLockName,
      Password: this.state.selectedLockPassword,
      Type: 4,
      ip45SerialNumber: this.state.selectedLockSerial,
      isShared: true,
      shareStartTime: this.state.selectedStartShareTime,
      shareEndTime: this.state.selectedEndShareTime,
      sharedBy: auth.currentUser.email,

      //NEW INDUSTRIAL FEATURES
      id: this.state.selectedLockID,
      ownedBy: this.state.selectedLockOwnedBy,
      shareAccessToken: this.state.randomlyGeneratedAccessToken,
      shareCount: incrementor,
      identifier: "",
      isOfflineLock: isOfflineModeBool,
    };
    fire
      .database()
      .ref("userLocks")
      .child(this.state.selectedFriendsUID)
      .push(lockData);
    alert("Access of " + this.state.selectedLockName + " given!");
    // window.location.reload();
  }

  pushUserAccessRegistryOnlineAccessToFirebase() {
    let key = fire
      .database()
      .ref("retractableSharingRegistry")
      .push().key;
    if (this.state.isRetractMode === true) {
      // //USE THIS FORMAT TO GENERATE THE PARENT ID
      var registryData = {
        shareStartTime: this.state.selectedStartShareTime,
        shareEndTime: this.state.selectedEndShareTime,
        sharedOn: new Date() / 1000,
        sharedToUID: auth.currentUser.uid,
        sharedToEmail: this.state.selectedFriendsEmail,
        senderUID: auth.currentUser.uid,
        sharedLockName: this.state.selectedLockName,
        lockSerial: this.state.selectedLockSerial,
        lockId: this.state.selectedLockID,
        allowAccess: true,
        id: key,
        shareAccessToken: this.state.randomlyGeneratedAccessToken,
      };
      fire
        .database()
        .ref("retractableSharingRegistry")
        .child(auth.currentUser.uid)
        .child(key)
        .update(registryData);
    } else {
      //DO NOTHING
    }
  }

  multiplePushShareUserRecordToShareHistory(email) {
    var shareHistoryObject = {
      sharedTo: email,
      lockName: this.state.selectedLockName,
      startDate: this.state.selectedStartTimeString,
      endDate: this.state.selectedEndTimeString,
      sharedOn: new Date().toDateString(),
    };
    fire
      .database()
      .ref("MyShareHistory")
      .child(auth.currentUser.uid)
      .push(shareHistoryObject);
  }

  pushShareUserRecordToShareHistory() {
    var shareHistoryObject = {
      sharedTo: this.state.selectedFriendsEmail,
      lockName: this.state.selectedLockName,
      startDate: this.state.selectedStartTimeString,
      endDate: this.state.selectedEndTimeString,
      sharedOn: new Date().toDateString(),
    };
    fire
      .database()
      .ref("MyShareHistory")
      .child(auth.currentUser.uid)
      .push(shareHistoryObject);
  }

  renderDropdown() {
    return _.map(this.state.locklistArray, (lockData) => {
      return <option key={lockData.uid}>{lockData.Name}</option>;
    });
  }

  renderDropdown2() {
    return _.map(this.state.userFriendListArray, (recipientData) => {
      return <option value={recipientData}>{recipientData}</option>;
    });
  }

  renderLockListArray() {
    if (!this.state.locklistArray) {
      return (
        <tr style={center}>
          <td colSpan="7">
            <NoDataFound />
          </td>
        </tr>
      );
    }
    if (this.state.loading) {
      return (
        <tr style={center}>
          <td colSpan="7">
            <Loading />
          </td>
        </tr>
      );
    } else {
      return _.map(this.state.locklistArray, (shareData) => {
        return (
          <tr>
            <td>{shareData.Name}</td>
            <td>{this.SharedLock(shareData.sharedBy)}</td>
          </tr>
        );
      });
    }
  }

  SharedLock(sharedBy) {
    if (sharedBy === "") {
      return "Non Shared Lock";
    } else {
      return sharedBy;
    }
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  ApprovalStatusInfo() {
    return _.map(this.state.ASArray, (index) => {
      return (
        <div>
          <p>{index.Placemark}</p>
          {this.auditTrailLockUnlockSubComponent(index.lockedStatus)}
          <TimeStamp time={index.time / 1000} format="full" includeDay />
          <p>{index.userEmail}</p>
          <hr></hr>
          {/* Look up the user's name? */}
        </div>
      );
    });
  }

  loadingData() {
    if (this.state.loading) {
      return (
        <div style={{ textAlign: "center" }}>
          <Loading />
        </div>
      );
    } else {
      return (
        <div style={{ textAlign: "center" }}>
          <NoDataFound />
        </div>
      );
    }
  }

  handlewindowShow(event) {
    event.preventDefault();
  }

  alertWhenChanged(event) {
    customLog("event: " + event.id);
  }

  handleClick(position) {
    var level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-bell"></span>,
      message: <div>Test Message</div>,
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }

  eraseAll() {
    customLog("eraseAll called");
    window.location.reload();
  }

  render() {
    const groupNames = _.map(this.state.groupNameArray, (data) => {
      return {
        name: data.groupName,
        id: data.id,
      };
    });

    const userlistdata = _.map(this.state.userArray, (userdata) => {
      return {
        key: userdata.uid,
        name: userdata.name,
        email: userdata.email,
        date: "empty",
        approval: "empty",
      };
    });

    // const friends = _.map(this.state.userFriendListArray, userdata => {
    //   // customLog(userdata)
    //   return (
    //     {
    //       id: userdata,
    //       name: userdata
    //     }
    //   );
    // });

    const userarray = [
      {
        dataField: "key",
        text: "key",
        hidden: true,
      },
      {
        dataField: "name",
        text: "Name(名前)",
      },
      {
        dataField: "email",
        text: "Email",
      },
      {
        dataField: "date",
        text: "Date",
      },
      {
        dataField: "approval",
        text: "Approval Status",
      },
    ];

    const customTotal = (from, to, size) => (
      <span className="react-bootstrap-table-pagination-total">
        Showing {from} to {to} of {size} Results
      </span>
    );

    const options = {
      paginationSize: 4,
      pageStartIndex: 1,
      // alwaysShowAllBtns: true, // Always show next and previous button
      // withFirstAndLast: false, // Hide the going to First and Last page button
      // hideSizePerPage: true, // Hide the sizePerPage dropdown always
      // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
      firstPageText: "<<",
      prePageText: "<",
      nextPageText: ">",
      lastPageText: ">>",
      nextPageTitle: "First page",
      prePageTitle: "Pre page",
      firstPageTitle: "Next page",
      lastPageTitle: "Last page",
      showTotal: true,
      paginationTotalRenderer: customTotal,
      sizePerPageList: [
        {
          text: "5",
          value: 5,
        },
        {
          text: "10",
          value: 10,
        },
        {
          text: "All",
          value: userlistdata.length,
        },
      ], // A numeric array is also available. the purpose of above example is custom the text
    };

    return (
      <div style={{ maxWidth: "95%", margin: "auto", marginTop: "2%" }}>
        {/* <div className="header">
          <h2>Grant Access(group)</h2>
        </div> */}

        {/* <Tabs defaultIndex={0} onSelect={index => customLog(index)}> */}
        {/* <TabList>
            <Tab>Lock Sharing</Tab>
            <Tab>Approval Status</Tab>
          </TabList> */}

        {/* <TabPanel> */}
        <br />
        <br />
        <div
          style={{
            maxWidth: "80%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <form onSubmit={this.handlewindowShow}>
            <FormGroup>
              <div style={{ display: "flex" }}>
                <div style={{ width: "60%" }}>
                  <ControlLabel
                    style={{ whiteSpace: "nowrap", fontSize: "18px" }}
                  >
                    Please Select a lock - (ハードウェアを選択して下さい):
                  </ControlLabel>
                </div>

                <div style={{ width: "40%" }}>
                  <FormControl
                    componentClass="select"
                    placeholder="select"
                    onChange={this.detectOnLockDropdownChangeEvent}
                  >
                    <option value="null"></option>
                    {this.renderDropdown()}
                  </FormControl>
                </div>
              </div>
              <br />
              <br />

              <div style={{ display: "flex" }}>
                <div style={{ width: "60%" }}>
                  <ControlLabel
                    style={{ whiteSpace: "nowrap", fontSize: "18px" }}
                  >
                    Please Select a Group - (サブユーザー選択して下さい):{" "}
                  </ControlLabel>
                </div>

                <div
                  style={{
                    justifyContent: "space-between",
                    display: "flex",
                    width: "40%",
                  }}
                >
                  {/* <div style={{ width: "48%" }}>
                        <FormControl
                          componentClass="select"
                          placeholder="select"
                          onChange={this.detectOnRecipientDropdownChangeEvent}                                        >
                          <option value="null">Select Group</option>
                          {this.renderDropdown2()}
                        </FormControl>
                      </div> */}

                  <div style={{ width: "100%" }}>
                    <Multiselect
                      // data={friends}
                      data={groupNames}
                      valueField="id"
                      textField="name"
                      onChange={this.handleFriendsArray}
                      onSelect={this.detectOnRecipientDropdownChangeEvent}
                    />
                  </div>
                </div>
              </div>

              <div style={{ display: "flex" }}>
                {/* <div style={{ display: "flex", marginRight: "34px" }}>
                      <label htmlFor="normal-switch" style={{ width: "250px" }}>
                        <strong>Requires Approval</strong>
                        <small>(承認が必要)</small>

                      </label>

                      <Switch
                        onChange={this.handleRequireApproval}
                        checked={this.state.approvalchecked}
                        id="normal-switch"

                      />
                    </div> */}

                <div style={{ width: "100%" }}>
                  <span>
                    {this.state.approvalchecked ? (
                      <FormControl
                        componentClass="select"
                        placeholder="select"
                        onChange={this.detectOnRecipientDropdownChangeEvent}
                      >
                        <option value="">
                          Select users to request approval
                        </option>
                        {this.renderDropdown2()}
                      </FormControl>
                    ) : (
                      ""
                    )}
                  </span>
                </div>
              </div>
              <br />
              <br />

              <div style={{ display: "flex" }}>
                <div style={{ display: "flex", marginRight: "50px" }}>
                  <label htmlFor="normal-switch" style={{ width: "250px" }}>
                    <strong>Timed Access</strong>
                    <small>(時限アクセス)</small>
                  </label>

                  <Switch
                    onChange={this.handleTimedAccess}
                    checked={this.state.timechecked}
                    id="normal-switch"
                  />
                </div>

                <div style={{ display: "flex" }}>
                  <span>
                    {this.state.timechecked ? (
                      <Row>
                        <DatePicker
                          placeholderText={this.state.calendarStartText}
                          selected={this.state.startDate}
                          onChange={this.handleStartDateChange}
                          showTimeSelect
                          dateFormat="Pp"
                        />
                        <span>アクセス開始時間</span>
                        <br />

                        <DatePicker
                          placeholderText={this.state.calendarEndText}
                          selected={this.state.endDate}
                          onChange={this.handleEndDateChange}
                          showTimeSelect
                          dateFormat="Pp"
                        />
                        <span>アクセス終了時間</span>
                      </Row>
                    ) : (
                      ""
                    )}
                  </span>
                </div>
              </div>
              <br />
              <br />

              <div style={{ display: "flex" }}>
                <div style={{ display: "flex", marginRight: "35px" }}>
                  <label htmlFor="normal-switch" style={{ width: "250px" }}>
                    <strong>Sharing Mode</strong>
                    <small>(アクセス削除モード)</small>
                  </label>

                  <Switch
                    onChange={this.handleChange}
                    checked={this.state.isRetractMode}
                    id="normal-switch"
                  />
                </div>
                <div>
                  <span>
                    {this.state.isRetractMode ? (
                      <p style={{ color: "red" }}>
                        Online: User has to be online to access lock
                      </p>
                    ) : (
                      <p style={{ color: "grey" }}>
                        Offline: Once Shared Cannot Retract
                      </p>
                    )}
                  </span>
                </div>
              </div>
              <br />
              <br />

              <Row>
                <Button
                  style={{ width: "100%", marginTop: "20px" }}
                  type="reset"
                  onClick={this.eraseAll}
                >
                  Clear All <small>クリア</small>
                </Button>
              </Row>

              {/* <Row>
                    <Button
                      className="btn btn-primary btn-fill"
                      style={{ width: "100%", marginTop: "20px" }}
                      type="submit"
                      onClick={() => {
                        if (
                          this.state.selectedLockName !== "" &&
                          this.state.selectedFriendsAccountExists == true
                        ) {
                          //OKAY BOTH THE LOCK AND RECIPIENT ARE SELECTED
                          if (
                            this.state.endDate !== 0 &&
                            this.state.startDate !== 0
                          ) {
                            if (this.state.startDate > this.state.endDate) {
                              //DONT SEND THE LOCK THE TIME IS WRONG
                              alert("Please Check Your Dates!");
                            } else {
                              //SEND THE LOCK THERE IS TIME
                              this.pushSelectedLockToSelectedUser();
                              this.pushUserAccessRegistryOnlineAccessToFirebase();
                              this.pushShareUserRecordToShareHistory();
                            }
                          } else {
                            //SEND THE LOCK ITS OK ALL TIME SHARING
                            this.pushSelectedLockToSelectedUser();
                            this.pushUserAccessRegistryOnlineAccessToFirebase();
                            this.pushShareUserRecordToShareHistory();
                          }
                        } else {
                          alert("Sorry! Something is Wrong, Please Check!");


                        }
                      }}
                    >
                      <strong>Send Remote Access</strong>
                      <small>アクセス権限を与える</small>
                    </Button>
                  </Row> */}

              <Row>
                <Button
                  className="btn btn-primary btn-fill"
                  style={{ width: "100%", marginTop: "20px" }}
                  onClick={() => {
                    if (!this.state.selectedLockName) {
                      alert("Please Select a Lock");
                    } else {
                      if (
                        this.state.selectedFriendsArray === "empty" ||
                        this.state.selectedFriendsArray[0] === undefined
                      ) {
                        alert("Please select a group");
                      } else {
                        if (window.confirm("Confirm Grant Access?")) {
                          this.lookUpAllUIDsGivenEmailsThenShareLocksToMultipleUsers(
                            this.state.selectedFriendsArray
                          );
                        }

                        // window.location.reload();
                      }
                    }
                  }}
                >
                  <strong>Send Remote Access</strong>
                  <small>アクセス権限を与える</small>
                </Button>
              </Row>
            </FormGroup>
          </form>
        </div>
        {/* </TabPanel>
          <TabPanel> */}
        <br />
        <br />
        <div
          style={{
            maxWidth: "80%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <form>
            <FormGroup>
              <div style={{ display: "flex", width: "50%" }}>
                <FormControl
                  style={{
                    marginRight: "20px",
                  }}
                  componentClass="select"
                  placeholder="select"
                  onChange={this.detectOnLockDropdownChangeEvent}
                >
                  <option value="">Group Name</option>
                  {this.renderDropdown()}
                </FormControl>

                <FormControl
                  style={{
                    marginLeft: "20px",
                  }}
                  componentClass="select"
                  placeholder="select"
                  onChange={this.detectOnLockDropdownChangeEvent}
                >
                  <option value="">Lock Name</option>
                  {this.renderDropdown()}
                </FormControl>
              </div>
              <br />
              <br />

              <div style={{ display: "flex" }}>
                <ControlLabel
                  style={{
                    whiteSpace: "nowrap",
                    marginRight: "9px",
                    fontSize: "18px",
                  }}
                >
                  Enter Approval ID
                </ControlLabel>
                <FormControl
                  componentClass="select"
                  placeholder="select"
                  onChange={this.detectOnLockDropdownChangeEvent}
                >
                  <option value="null"></option>
                  {this.renderDropdown()}
                </FormControl>
              </div>
              <br />
              <br />

              <div style={{ border: "1px solid grey", borderRadius: "5px" }}>
                <div
                  style={{
                    width: "90%",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                >
                  <ToolkitProvider
                    keyField="key"
                    data={userlistdata}
                    columns={userarray}
                  >
                    {(props) => (
                      <div>
                        <br />
                        <BootstrapTable
                          keyField="key"
                          data={userlistdata}
                          columns={userarray}
                          bordered={false}
                          noDataIndication={this.loadingData()}
                          // cellEdit={cellEditFactory({ mode: 'click' })}
                          pagination={paginationFactory(options)}
                          {...props.baseProps}
                        />
                      </div>
                    )}
                  </ToolkitProvider>
                </div>
              </div>
            </FormGroup>
          </form>
        </div>
        {/* </TabPanel>
        </Tabs> */}
      </div>
    );
  }
}

const authCondition = (authUser) => !!authUser;
export default withAuthorization(authCondition)(GroupShare);
